import { Record } from 'immutable';
import FilterDefinitionTypeConstants from '~/constants/filter-definition-type-constants';
import NameRecord from '~/ducks/machine-filter-v2/data/NameRecord';
import formatMessageWrapper from '~/utils/format-message-wrapper/format-message-wrapper';
import {
  baseKeys,
  FilterDefinitionTypeBaseFields,
  FilterDefinitionTypeMethods,
} from './FilterTypeDefinitionBase';

const keys: Fields = {
  ...baseKeys,
  type: FilterDefinitionTypeConstants.TEXT,
};

export interface Fields extends FilterDefinitionTypeBaseFields {
  type: FilterDefinitionTypeConstants.TEXT;
}

export default class FreeTextFilterDefinitionTypeRecord
  extends Record<Fields>(keys)
  implements FilterDefinitionTypeMethods {
  constructor(values?) {
    super(values);

    const newValues: Partial<Fields> = {};

    if (values) {
      if (values.name) {
        newValues.name = new NameRecord(values.name);
      }
    }

    return this.merge(newValues);
  }

  getFilterKey(): string {
    return this.name.getName();
  }

  getName(): string {
    return this.name.getName();
  }

  getTranslationKey(): string {
    return this.name.getTranslationKey() || '';
  }

  getNameRecord(): NameRecord {
    return this.name;
  }

  getType() {
    return this.type;
  }

  getFormattedFilterName(): string {
    return formatMessageWrapper(this.getTranslationKey());
  }
}
